import { render } from "./ioConfig.vue?vue&type=template&id=ca1fc256&scoped=true"
import script from "./ioConfig.vue?vue&type=script&lang=js"
export * from "./ioConfig.vue?vue&type=script&lang=js"

import "./ioConfig.vue?vue&type=style&index=0&id=ca1fc256&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1fc256"]])

export default __exports__